import type { ExpenseThisMonthDTO } from "../models/expenseThisMonthDto";
import type { ExpenseThisMonthEntity } from "../../domain/entities/ExpenseThisMonthEntity";

export function expenseThisMonthDtoToEntity(
  dto: ExpenseThisMonthDTO,
): ExpenseThisMonthEntity {
  return {
    expenseThisWeek: Number(dto.expenseThisWeek) || 0,
    expenseThisMonth: Number(dto.expenseThisMonth) || 0,
    subTotalThisWeek: Number(dto.subTotalThisWeek) || 0,
    taxTotalThisWeek: Number(dto.taxTotalThisWeek) || 0,
    subTotalThisMonth: Number(dto.subTotalThisMonth) || 0,
    taxTotalThisMonth: Number(dto.taxTotalThisMonth) || 0,
    monthLabel: String(dto.monthLabel ?? ""),
    weekNumberInMonth: Number(dto.weekNumberInMonth) || 1,
    totalWeeksInMonth: Number(dto.totalWeeksInMonth) || 1,
    weekStart: String(dto.weekStart ?? ""),
    weekEnd: String(dto.weekEnd ?? ""),
  };
}
